// extracted by mini-css-extract-plugin
module.exports = {"testimonialWrapper":"testimonial_testimonialWrapper__fLlJQ","blockquoteStyles":"testimonial_blockquoteStyles__soqZG"};